import type React from 'react'
import {
	Popover,
	PopoverTrigger,
	PopoverContent,
	PopoverArrow,
	PopoverCloseButton,
	PopoverBody,
} from '@chakra-ui/react'
import type { ChakraProps } from '@chakra-ui/react'
import { QuestionmarkCircleIcn } from '@alexanderathoodly/ui-library'

export const InputInfoPopover: React.FC<
	React.PropsWithChildren<ChakraProps>
> = ({ children, ...rest }) => (
	<Popover>
		<PopoverTrigger>
			<QuestionmarkCircleIcn
				color="blue.500"
				_hover={{ cursor: 'pointer' }}
				{...rest}
			/>
		</PopoverTrigger>
		<PopoverContent>
			<PopoverArrow />
			<PopoverCloseButton />
			<PopoverBody>{children}</PopoverBody>
		</PopoverContent>
	</Popover>
)
